import React from 'react';
import { searchContext } from '../../../../context/Context';
import { OpenPopup } from './OpenPopup';

export function ScoreHeader() {
  const { tab } = searchContext();
  
  return tab === 'GDA' ? (
    <>
      <span title="Gene-Disease Association Score">
        Score<sub>gda</sub>
      </span>
      <OpenPopup popupType="showScore" />
    </>
  ) : (
    <span title="Variant-Disease Association Score">
      Score<sub>vda</sub>
    </span>
  );
}